

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaPlus } from 'react-icons/fa';
import { useNavigate, useParams } from "react-router-dom";
import Navbar from '../../../../Shared/ManagerNavbar/Navbar';
import { baseURL } from '../../../../Apiservices/Api';
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import DataTable from "../../../../Layout/Table/TableLayout";
import './MySupplier.css';

const M_MySupplierTable = () => {
  const [suppliers, setSuppliers] = useState([]); 
  const [totals, setTotals] = useState({
    totalPayable: 0,
    paidAmount: 0,
    balancePayment: 0,
  });
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("payables");
  const { leadid } = useParams();

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const fetchSuppliers = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/suppliers?leadid=${leadid}`);
      const supplierList = res.data;
  
      // Fetch total_paid for each supplier
      const enrichedSuppliers = await Promise.all(
        supplierList.map(async (supplier) => {
          const { id: supplier_id } = supplier;
  
          try {
            const paymentRes = await axios.get(`${baseURL}/api/payment-log`, {
              params: { leadid, supplier_id },
            });
  
            const totalPaid = paymentRes.data.total_paid || 0;
  
            return {
              ...supplier,
              paid_amount: totalPaid,
              balance_payment: (Number(supplier.total_payable || 0) - totalPaid).toFixed(2),
            };
          } catch (err) {
            console.error(`Error fetching payment log for supplier ${supplier_id}:`, err);
            return {
              ...supplier,
              paid_amount: 0,
              balance_payment: supplier.total_payable,
            };
          }
        })
      );
  
      setSuppliers(enrichedSuppliers);
  
      // Calculate totals
      const totals = enrichedSuppliers.reduce(
        (acc, curr) => {
          acc.totalPayable += Number(curr.total_payable || 0);
          acc.paidAmount += Number(curr.paid_amount || 0);
          acc.balancePayment += Number(curr.balance_payment || 0);
          return acc;
        },
        { totalPayable: 0, paidAmount: 0, balancePayment: 0 }
      );
  
      setTotals(totals);
    } catch (err) {
      console.error('Error fetching suppliers:', err);
    }
  };
  

  const columns = [
    {
      Header: "S.No",
      accessor: (_, rowIndex) => rowIndex + 1,
      Cell: ({ row }) => row.index + 1,
    },
    { Header: "Supplier Name", accessor: "supplier_name" },
    { Header: "Total Payable", accessor: "total_payable" },
    // {
    //   Header: "Paid On",
    //   accessor: (row) => {
    //     const date = new Date(row.paid_on);
    //     const day = String(date.getDate()).padStart(2, "0");
    //     const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    //     const year = date.getFullYear();
    //     const hours = String(date.getHours()).padStart(2, "0");
    //     const minutes = String(date.getMinutes()).padStart(2, "0");

    //     return `${day}/${month}/${year} ${hours}:${minutes}`;
    //   }
    // },
    { Header: "Paid Amount", accessor: "paid_amount" },
    { Header: "Balance Payment", accessor: "balance_payment" },
    { Header: "Comments", accessor: "comments" },
    // { Header: "Purpose of Payment", accessor: "purpose" },
    // { Header: "Status", accessor: "status" },
    {
      Header: "Actions",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <FaPlus
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() =>
              navigate(`/m-mysuppliers/${row.original.id}/${leadid}`, {
                state: { supplier: row.original },
              })
            }
          />
          {/* <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => navigate(`/s-suppliers/${row.original.id}/history`, {
              state: { supplier: row.original }
            })}
          >
            View
          </button> */}
          <FaEye
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => navigate(`/m-mysuppliers/${row.original.id}/history`, {
              state: { supplier: row.original }
            })}
          />
          {/* <FaEdit
            style={{ color: "#ff9966", cursor: "pointer" }}
            onClick={() => handleEdit(row.original.leadid)}
          /> */}
          {/* <FaTrash
            style={{ color: "#ff9966", cursor: "pointer" }}
            // onClick={() => handleDelete(row.original.leadid)}
          /> */}
        </div>
      ),
    }

  ];

  const tableData = suppliers.map((supplier, index) => ({
    ...supplier,
    serial: index + 1
  }));

  return (
    <div className="salesViewLeadsContainer">
      <Navbar />
      <div className="salesViewLeads">
        <div className="payments-tabs">
          <button
            className={activeTab === "payables" ? "active" : ""}
            onClick={() => setActiveTab("payables")}
          >
            Payables
          </button>
          <button
            className={activeTab === "receivables" ? "active" : ""}
            onClick={() => {
              setActiveTab("receivables");
              navigate(`/m-mypayments/${leadid}`);
            }}
          >
            Receivables
          </button>
        </div>
        <div className="tableHeader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>
          <h3>Supplier List</h3>
          <button
            className="addSupplierBtn"
            onClick={() => navigate(`/m-add-mysupplier/${leadid}`)}
          >
            + Add Supplier
          </button>
        </div>

        {/* Totals Section */}
        <div className="totals-summary" style={{
          margin: "20px 0",
          backgroundColor: "#f9f9f9",
          border: "1px solid #ddd",
          padding: "15px",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "space-around",
          fontWeight: "bold"
        }}>
          <span>Total Payable: ₹ {totals.totalPayable.toFixed(2)}</span>
          <span>Paid Amount: ₹ {totals.paidAmount.toFixed(2)}</span>
          <span>Balance Payment: ₹ {totals.balancePayment.toFixed(2)}</span>
        </div>

        <DataTable columns={columns} data={tableData} />
      </div>
    </div>
  );
};

export default M_MySupplierTable;

// const M_MySupplierTable = () => {
//   const [suppliers, setSuppliers] = useState([]);
//   const [totals, setTotals] = useState({
//     totalPayable: 0,
//     paidAmount: 0,
//     balancePayment: 0,
//   });
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("payables");
//   const { leadid } = useParams();

//   useEffect(() => {
//     fetchSuppliers();
//   }, []);

//   const fetchSuppliers = async () => {
//     try {
//       const res = await axios.get(`${baseURL}/api/suppliers?leadid=${leadid}`);
//       setSuppliers(res.data);

//       // Calculate totals
//       const totals = res.data.reduce(
//         (acc, curr) => {
//           acc.totalPayable += Number(curr.total_payable || 0);
//           acc.paidAmount += Number(curr.paid_amount || 0);
//           acc.balancePayment += Number(curr.balance_payment || 0);
//           return acc;
//         },
//         { totalPayable: 0, paidAmount: 0, balancePayment: 0 }
//       );

//       setTotals(totals);
//     } catch (err) {
//       console.error('Error fetching suppliers:', err);
//     }
//   };

//   const columns = [
//     {
//       Header: "S.No",
//       accessor: (_, rowIndex) => rowIndex + 1,
//       Cell: ({ row }) => row.index + 1,
//     },
//     { Header: "Supplier Name", accessor: "supplier_name" },
//     { Header: "Total Payable", accessor: "total_payable" },
//     {
//       Header: "Paid On",
//       accessor: (row) => {
//         const date = new Date(row.paid_on);
//         const day = String(date.getDate()).padStart(2, "0");
//         const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
//         const year = date.getFullYear();
//         const hours = String(date.getHours()).padStart(2, "0");
//         const minutes = String(date.getMinutes()).padStart(2, "0");

//         return `${day}/${month}/${year} ${hours}:${minutes}`;
//       }
//     },
//     { Header: "Paid Amount", accessor: "paid_amount" },
//     { Header: "Balance Payment", accessor: "balance_payment" },
//     { Header: "Comments", accessor: "comments" },
   
//     // { Header: "Status", accessor: "status" },
//     {
//       Header: "Actions",
//       Cell: ({ row }) => (
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           <FaPlus
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             onClick={() =>
//               navigate(`/m-mysuppliers/${row.original.id}/${leadid}`, {
//                 state: { supplier: row.original },
//               })
//             }
//           />
//           {/* <button
//             className="btn btn-sm btn-outline-primary"
//             onClick={() => navigate(`/m-mysuppliers/${row.original.id}/history`, {
//               state: { supplier: row.original }
//             })}
//           >
//             View
//           </button> */}
//           <FaEye
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             onClick={() => navigate(`/m-mysuppliers/${row.original.id}/history`, {
//               state: { supplier: row.original }
//             })}
//           />
//           {/* <FaEdit
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             onClick={() => handleEdit(row.original.leadid)}
//           /> */}
//           {/* <FaTrash
//             style={{ color: "#ff9966", cursor: "pointer" }}
//             // onClick={() => handleDelete(row.original.leadid)}
//           /> */}
//         </div>
//       ),
//     }

//   ];

//   const tableData = suppliers.map((supplier, index) => ({
//     ...supplier,
//     serial: index + 1
//   }));

//   return (
//     <div className="salesViewLeadsContainer">
//       <Navbar />
//       <div className="salesViewLeads">
//         <div className="payments-tabs">
//           <button
//             className={activeTab === "payables" ? "active" : ""}
//             onClick={() => setActiveTab("payables")}
//           >
//             Payables
//           </button>
//           <button
//             className={activeTab === "receivables" ? "active" : ""}
//             onClick={() => {
//               setActiveTab("receivables");
//               navigate(`/m-mypayments/${leadid}`);
//             }}
//           >
//             Receivables
//           </button>
//         </div>
//         <div className="tableHeader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>
//           <h3>Supplier List</h3>
//           <button
//             className="addSupplierBtn"
//             onClick={() => navigate(`/m-add-mysupplier/${leadid}`)}
//           >
//             + Add Supplier
//           </button>
//         </div>

//         {/* Totals Section */}
//         <div className="totals-summary" style={{
//           margin: "20px 0",
//           backgroundColor: "#f9f9f9",
//           border: "1px solid #ddd",
//           padding: "15px",
//           borderRadius: "8px",
//           display: "flex",
//           justifyContent: "space-around",
//           fontWeight: "bold"
//         }}>
//           <span>Total Payable: ₹ {totals.totalPayable.toFixed(2)}</span>
//           <span>Paid Amount: ₹ {totals.paidAmount.toFixed(2)}</span>
//           <span>Balance Payment: ₹ {totals.balancePayment.toFixed(2)}</span>
//         </div>

//         <DataTable columns={columns} data={tableData} />
//       </div>
//     </div>
//   );
// };

// export default M_MySupplierTable;